<template>
  <div class="campaignTable">
    <slot-table :data="tableData" :columns="table.columns">

      <template slot="name" slot-scope="props">
        <span>
          <router-link :to="{ path: `/campaigns/${props.item.hash_id}` }">{{ props.item.name }}</router-link>
        </span>
      </template>

      <template slot="date_created" slot-scope="props">
        <span>{{ props.item.date_created.value | formatDate }}</span>
      </template>

      <template slot="is_archived" slot-scope="props">
        <span v-if="props.item.is_archived" class="label label-pill label-warning">Archived</span><span v-else class="label label-pill label-success">Active</span>
      </template>

      <template slot="campaign_job_number" slot-scope="props">
        <span class="text-capitalize">{{ props.item.campaign_job_number }}</span>
      </template>

      <template slot="campaign_actions" slot-scope="props">
        <button-cta title="edit" data-modalType="editCampaign" :data-modalField="props.item.name" :data-modalId="props.item.hash_id"
                    :onClick="launchActionModal" class="btn btn-warning btn-xs">
          <i class="fa fa-pencil" aria-hidden="true"></i></button-cta>
        <button-cta title="clone" data-modalType="cloneCampaign" :data-modalId="props.item.hash_id"
                    :onClick="launchActionModal" class="btn btn-success btn-xs">
          <i class="fa fa-clone" aria-hidden="true"></i>
        </button-cta>
        <button-cta title="confirm" data-modalType="deleteCampaign" :data-modalId="props.item.hash_id"
                    :onClick="launchActionModal" class="btn btn-danger btn-xs">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button-cta>
      </template>

    </slot-table>
  </div>
</template>

<script>
import SlotTable from '@/components/Table/table'
import ButtonCta from '@/components/Button/button'
import Heading from '@/components/Heading/heading'
import Field from '@/components/Form/Field/field'
import SwitchButton from '@/components/SwitchButton/switch-button'
import Checkbox from '@/components/Form/Checkbox/checkbox'
import {campaignMixin} from '@/mixins/campaignMixin'

export default {
  name: 'campaignTable',
  mixins: [campaignMixin],
  components: {
    SlotTable,
    ButtonCta,
    Field,
    SwitchButton,
    Checkbox,
    Heading
  },
  props: {
    tableData: Array,
    launchActionModal: Function
  },
  data: () => ({
    table: {
      columns: {
        name: 'Name',
        campaign_job_number: 'Campaign Job Number',
        date_created: 'Date Created',
        is_archived: 'Status',
        campaign_actions: ''
      }
    }
  }),
  methods: {}
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/CampaignTable/campaign-table.vue